module.exports = __webpack_public_path__ + "img/parttwo_pic2.b8df3006.png";